module.exports = __webpack_public_path__ + "static/img/RW664_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW664_1.png
// module id = 0CnW
// module chunks = 0